export class Permission {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "permissionType",
            "baseName": "permissionType",
            "type": "PermissionType",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "allowConditions",
            "baseName": "allowConditions",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "areas",
            "baseName": "areas",
            "type": "Array<PermissionArea>",
            "format": ""
        },
        {
            "name": "category",
            "baseName": "category",
            "type": "PermissionActionCategory",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Permission.attributeTypeMap;
    }
    constructor() {
    }
}
